<template>
  <div class="finance">
    <el-row :gutter="24" class="finance-cards">
      <el-col :span="8">
        <el-card shadow="hover" class="finance-card">
          <p class="card-label">账户余额 (元)</p>
          <h3 class="card-value red-text">&yen; {{ formatMoney(financeData.balance) }}</h3>
          <div class="card-actions">
            <el-button type="primary" size="small" @click="$router.push('/withdraw')">提现</el-button>
            <el-button size="small" plain>充值详情</el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="finance-card">
          <p class="card-label">冻结金额 (元)</p>
          <h3 class="card-value grey-text">&yen; {{ formatMoney(financeData.frozen) }}</h3>
          <p class="card-tip"><i class="el-icon-info"></i> 包含未过维权期的订单金额</p>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="finance-card">
          <p class="card-label">总资产 (元)</p>
          <h3 class="card-value">&yen; {{ formatMoney(financeData.total) }}</h3>
          <p class="card-trend up" v-if="financeData.dailyChange > 0">较昨日 +&yen; {{ formatMoney(financeData.dailyChange) }}</p>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" style="margin-top:20px">
      <div slot="header" class="card-header">
        <span>资金流水</span>
        <div class="header-filters">
          <el-date-picker v-model="flowDateRange" type="daterange" range-separator="-" start-placeholder="开始" end-placeholder="结束" size="small" value-format="yyyy-MM-dd" />
          <el-select v-model="flowType" placeholder="类型" size="small" clearable style="width:120px">
            <el-option label="全部" value="" />
            <el-option label="收入" value="income" />
            <el-option label="支出" value="expense" />
            <el-option label="提现" value="withdraw" />
          </el-select>
          <el-button type="primary" size="small" @click="loadFlowList">查询</el-button>
        </div>
      </div>
      <el-table :data="flowList" border stripe v-loading="flowLoading">
        <el-table-column prop="create_time" label="时间" width="160" />
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 'income' ? 'success' : scope.row.type === 'withdraw' ? 'warning' : 'danger'" size="small">
              {{ scope.row.type === 'income' ? '收入' : scope.row.type === 'withdraw' ? '提现' : '支出' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="120">
          <template slot-scope="scope">
            <span :style="{color: scope.row.type === 'income' ? '#67c23a' : '#f56c6c'}">
              {{ scope.row.type === 'income' ? '+' : '-' }}&yen; {{ scope.row.amount || 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="余额" width="120">
          <template slot-scope="scope">&yen; {{ scope.row.balance || 0 }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip />
      </el-table>
      <div class="pagination-box">
        <el-pagination background layout="total, prev, pager, next" :total="flowTotal" :page-size="10" :current-page="flowPage" @current-change="onFlowPageChange" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getFinance, getFinanceFlowList } from '@/api'

export default {
  name: 'Finance',
  data() {
    return {
      financeData: { balance: 0, frozen: 0, total: 0, dailyChange: 0 },
      flowList: [], flowLoading: false, flowTotal: 0, flowPage: 1,
      flowDateRange: [], flowType: ''
    }
  },
  mounted() {
    this.loadFinance()
    this.loadFlowList()
  },
  methods: {
    async loadFinance() {
      try {
        const res = await getFinance()
        this.financeData = res || {}
      } catch (e) {}
    },
    async loadFlowList() {
      this.flowLoading = true
      try {
        const params = { page: this.flowPage, limit: 10, type: this.flowType }
        if (this.flowDateRange && this.flowDateRange.length === 2) {
          params.start = this.flowDateRange[0]
          params.end = this.flowDateRange[1]
        }
        const res = await getFinanceFlowList(params)
        this.flowList = res.data || res || []
        this.flowTotal = res.total || 0
      } catch (e) {}
      this.flowLoading = false
    },
    onFlowPageChange(p) { this.flowPage = p; this.loadFlowList(); },
    formatMoney(val) {
      if (!val && val !== 0) return '--'
      return Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style scoped>
.finance-card { border-radius: 8px; }
.card-label { font-size: 13px; color: #909399; margin: 0 0 12px; }
.card-value { font-size: 32px; font-weight: bold; margin: 0 0 12px; color: #303133; }
.card-value.red-text { color: #3a8ee6; }
.card-value.grey-text { color: #c0c4cc; }
.card-actions { display: flex; gap: 8px; }
.card-tip { font-size: 12px; color: #c0c4cc; margin: 8px 0 0; }
.card-trend { font-size: 12px; margin: 8px 0 0; }
.card-trend.up { color: #67c23a; }
.card-header { display: flex; justify-content: space-between; align-items: center; }
.header-filters { display: flex; gap: 10px; align-items: center; }
.pagination-box { text-align: right; margin-top: 16px; }
</style>
